module.exports = __webpack_public_path__ + "src/images/products/allAmerican/89_2297 Mariniere Heritage Tee.png";